import { render, staticRenderFns } from "./BroughtTogether.vue?vue&type=template&id=1da3d94e"
import script from "./BroughtTogether.vue?vue&type=script&setup=true&lang=ts"
export * from "./BroughtTogether.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BroughtTogetherTile: require('/vercel/path0/components/BroughtTogetherTile.vue').default})
